import { useMemo } from "react";
import { useLanguage } from "../../../contexts/LanguageContext";

const useAboutSections = () => {
  const { t } = useLanguage();

  const sections = useMemo(
    () => [
      {
        id: "section1",
        title: t("ABOUT.SECTIONS.SECTION1.TITLE"),
        content: [
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION1.CONTENT.0"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/meheszet.JPG"),
            alt: "Méhészet",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION1.CONTENT.1"),
          },
          {
            role: "image",
            src: require("../../../assets/images/home/products.JPG"),
            alt: "Termékek",
          },
        ],
      },
      {
        id: "section2",
        title: t("ABOUT.SECTIONS.SECTION2.TITLE"),
        content: [
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION2.CONTENT.0"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/generacio.JPG"),
            alt: "Generációk",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION2.CONTENT.1"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/kisebb_generacio.JPG"),
            alt: "Kisebb generáció",
          },
        ],
      },
      {
        id: "section3",
        title: t("ABOUT.SECTIONS.SECTION3.TITLE"),
        content: [
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION3.CONTENT.0"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/szin.JPG"),
            alt: "Méhészet színes kaptárok",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION3.CONTENT.1"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/auto.JPG"),
            alt: "Vándorméhészet autó",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION3.CONTENT.2"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/tusnad.JPG"),
            alt: "Tusnádi méhészet",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION3.CONTENT.3"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/kiralyno.JPG"),
            alt: "Méhkirálynő",
          },
        ],
      },
      {
        id: "section4",
        title: t("ABOUT.SECTIONS.SECTION4.TITLE"),
        content: [
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.0"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.1"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.2"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.3"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.4"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/2022.JPG"),
            alt: "2022 díjak",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.5"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.6"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.7"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/2023.JPG"),
            alt: "2023 díjak",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.8"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/2024.JPG"),
            alt: "2024 díjak",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.9"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/2025.JPG"),
            alt: "2025 díjak",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.10"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.11"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.12"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.13"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.14"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.15"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.16"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.17"),
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION4.CONTENT.18"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/2026.JPG"),
            alt: "2026 díjak",
          },
        ],
      },
      {
        id: "section5",
        title: t("ABOUT.SECTIONS.SECTION5.TITLE"),
        content: [
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION5.CONTENT.0"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/cel.JPG"),
            alt: "Célunk",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION5.CONTENT.1"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/csoport.JPG"),
            alt: "Óvodás csoport",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION5.CONTENT.2"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/ovoda.JPG"),
            alt: "Óvoda látogatás",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION5.CONTENT.3"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/asztal.JPG"),
            alt: "Vásári asztal",
          },
          {
            role: "content",
            text: t("ABOUT.SECTIONS.SECTION5.CONTENT.4"),
          },
          {
            role: "image",
            src: require("../../../assets/images/about/automata.jpeg"),
            alt: "Automata",
          },
        ],
      },
    ],
    [t]
  );

  return sections;
};

export default useAboutSections;
